import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    const items = document.querySelectorAll('.accordion-item');
    items.forEach(item => {
        const button = item.querySelector('button.accordion-toggle');
        const icon = button.querySelector('.icon');
        button.addEventListener('click', () => {
            const isOpen = item.classList.toggle('open');
            icon.textContent = isOpen ? '–' : '+';
        });
    });
});
